// extracted by mini-css-extract-plugin
export default {"submitBtn":"buttons_submitBtn__hITtW","btnGen":"buttons_btnGen__1QNSx"};